import React from 'react';
import {RichText} from './rich';
export default ({text}) => <RichText children={text}/>